import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  class: "govuk-heading-xl",
  id: "page-heading-anchor"
}, "Advanced search", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "govuk-body" }, "Narrrow down your search with the following optional fields", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_Form, {
      fieldsets: _ctx.fieldsets,
      fields: _ctx.fields,
      buttons: _ctx.buttons,
      onFormHasPassedValidation: _ctx.saveFormData
    }, null, 8, ["fieldsets", "fields", "buttons", "onFormHasPassedValidation"])
  ], 64))
}